import "./Privacy.module.css";
import Navigation from "@/reusable_sections/Header";
import Privacy from "./sections/Privacy";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Navigation />
      <Privacy />
      <Footer />
    </div>;
}